import { type ChangeEvent } from 'react';
import { Plus, User } from 'lucide-react';
import type { Cliente } from '../../types';

interface Props {
  valor: string;
  resultados: Cliente[];
  clienteSeleccionado: Cliente | null;
  onCambioTexto: (texto: string) => void;
  onSeleccionar: (cliente: Cliente) => void;
  onSolicitarNuevo: () => void;
}

export function BuscadorCliente({
  valor,
  resultados,
  clienteSeleccionado,
  onCambioTexto,
  onSeleccionar,
  onSolicitarNuevo,
}: Props) {
  const mostrarBotonAgregar =
    valor && valor.length >= 2 && resultados.length === 0 && !clienteSeleccionado;

  return (
    <div className="md:col-span-2 relative">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        <User size={16} className="inline mr-1" />
        Cliente *
      </label>
      <input
        type="text"
        value={valor}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onCambioTexto(e.target.value)}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        placeholder="Buscar o escribir nombre del cliente..."
      />

      {resultados.length > 0 && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
          {resultados.map((cliente) => (
            <div
              key={cliente.id}
              onClick={() => onSeleccionar(cliente)}
              className="px-4 py-3 hover:bg-indigo-50 cursor-pointer border-b last:border-b-0"
            >
              <div className="font-medium text-gray-800">{cliente.nombre}</div>
              <div className="text-sm text-gray-600">{cliente.telefono}</div>
            </div>
          ))}
        </div>
      )}

      {mostrarBotonAgregar && (
        <div className="mt-2">
          <button
            onClick={onSolicitarNuevo}
            className="text-sm text-indigo-600 hover:text-indigo-800 flex items-center gap-1"
          >
            <Plus size={16} />
            Cliente no encontrado. ¿Agregar &quot;{valor}&quot; a la base de datos?
          </button>
        </div>
      )}
    </div>
  );
}
